import {useGetListLibraryModal, useGetListQueryModal} from "../../hooks/useJsonLoader";
import {DetailType} from "../../types/enums";
import {Correlation, Score} from "../../types/list";
import {useListContext} from "../../contexts/ListContext";

import {IoInformationCircleOutline} from "react-icons/io5";
import {GridRenderCellParams} from "@mui/x-data-grid";

interface ListRenderDetailProps<T extends Score | Correlation> {
  params: GridRenderCellParams<T, string>;
}

const ListRenderDetail = <T extends Score | Correlation>({params}: ListRenderDetailProps<T>) => {
  const {setSelectedRowModal, setLibraryModalResult, setQueryModalResult} = useListContext();

  const getLibraryModalResult = useGetListLibraryModal();
  const getQueryModalResult = useGetListQueryModal();

  const handleRowModal = () => {
    // qGI modal
    if (params.field === DetailType.QGI) {
      const scoreRow = params.row as Score;
      setSelectedRowModal(scoreRow);
      const screen_id = scoreRow.screen.split(/\s+/)[1];
      getLibraryModalResult({
        get_param: scoreRow.library_id
      }).then(library_results => {
        if (!library_results) return;
        setLibraryModalResult(library_results);
      });
      getQueryModalResult({
        get_param: screen_id
      }).then(query_results => {
        if (!query_results) return;
        setQueryModalResult(query_results);
      });
    }
    // Profile Similarity modal; re-use queryModalResult as container of Library Gene #1
    else {
      const corrRow = params.row as Correlation;
      setSelectedRowModal(corrRow);
      getLibraryModalResult({
        get_param: corrRow.g1_lid
      }).then(lib1_results => {
        if (!lib1_results) return;
        setQueryModalResult(lib1_results);
      });
      getLibraryModalResult({
        get_param: corrRow.g2_lid
      }).then(lib2_results => {
        if (!lib2_results) return;
        setLibraryModalResult(lib2_results);
      });
    }
  }

  return (
    <div className="w-100 d-flex align-items-center justify-content-center">
      <IoInformationCircleOutline
        className="icon-detail mouse-pointer fs-4"
        aria-label="Open Detail View"
        title="Open Detail View"
        onClick={handleRowModal}
      />
    </div>
  );
}

export default ListRenderDetail;
